import { ShieldCheck } from 'lucide-react';
import { C } from '../constants';

export default function AnonymousBadge({ size = 'md' }) {
  const sm = size === 'sm';
  return (
    <span
      className="inline-flex items-center gap-2"
      style={{
        background:    'rgba(0,229,255,0.08)',
        border:        '1px solid rgba(0,229,255,0.25)',
        padding:       sm ? '4px 10px' : '6px 14px',
        borderRadius:  999,
        fontSize:      sm ? '0.66rem' : '0.74rem',
        fontWeight:    600,
        color:         C.cyan,
        letterSpacing: '0.04em',
      }}
    >
      <ShieldCheck size={sm ? 12 : 14} />
      No data collected · 100% anonymous
    </span>
  );
}
